import { S3Client, ListObjectsV2Command, GetObjectCommand } from '@aws-sdk/client-s3';
import { awsConfig } from '../config/aws-config';

const s3Client = new S3Client({
  region: awsConfig.region,
  credentials: awsConfig.credentials,
  forcePathStyle: true,
  useAccelerateEndpoint: false,
  endpoint: `https://s3.${awsConfig.region}.amazonaws.com`
});

export const s3Service = {
  async listFolders() {
    try {
      const command = new ListObjectsV2Command({
        Bucket: awsConfig.bucketName,
        Prefix: awsConfig.folderPrefix,
        Delimiter: '/'
      });
      
      const response = await s3Client.send(command);
      return response.CommonPrefixes?.map(prefix => prefix.Prefix?.split('/').slice(-2)[0]) || [];
    } catch (error: any) {
      console.error('Error listing folders:', error);
      
      if (error.name === 'NetworkingError' || error.message?.includes('CORS')) {
        throw new Error('CORS error: Please ensure CORS is configured on the S3 bucket.');
      }
      
      throw error;
    }
  },

  async getFileContent(key: string) {
    try {
      // Check if the key starts with ICE-VEHICLE-LOOKUP or use the default prefix
      const fullKey = key.startsWith('ICE-VEHICLE-LOOKUP/') 
        ? key 
        : `${awsConfig.folderPrefix}${key}`;

      const command = new GetObjectCommand({
        Bucket: awsConfig.bucketName,
        Key: fullKey
      });
      
      const response = await s3Client.send(command);
      const content = await response.Body?.transformToString();
      
      return content || null;
    } catch (error: any) {
      console.error('Error getting file content:', error);
      
      if (error.name === 'NetworkingError' || error.message?.includes('CORS')) {
        throw new Error('CORS error: Please ensure CORS is configured on the S3 bucket.');
      }
      
      throw error;
    }
  },

  async loadDashboardData(folder: string) {
    try {
      // Load both client and network summary files
      const [clientContent, networkContent] = await Promise.all([
        this.getFileContent(`${folder}/client_api_summary.csv`),
        this.getFileContent(`${folder}/network_api_summary.csv`)
      ]);

      return {
        clientContent: clientContent || '',
        networkContent: networkContent || ''
      };
    } catch (error: any) {
      console.error('Error loading dashboard data:', error);
      throw error;
    }
  },

  async loadIceDashboardData(year: string, month: string) {
    try {
      // Load both client and network summary files from ICE folder structure
      const [clientContent, networkContent] = await Promise.all([
        this.getFileContent(`ICE-VEHICLE-LOOKUP/${year}/${month}/client_summary.csv`),
        this.getFileContent(`ICE-VEHICLE-LOOKUP/${year}/${month}/network_all.csv`)
      ]);

      return {
        clientContent: clientContent || '',
        networkContent: networkContent || ''
      };
    } catch (error: any) {
      console.error('Error loading ICE dashboard data:', error);
      throw error;
    }
  }
}; 